import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const ISSUES_SETTINGS_ROUTE_NAMES = new Set<string>([
	ROUTE_NAMES.GLOBAL_SETTINGS_CUSTOM_FIELDS,
	ROUTE_NAMES.GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE,
	ROUTE_NAMES.GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE,
	ROUTE_NAMES.GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE,
	ROUTE_NAMES.GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE,
	ROUTE_NAMES.GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUTS,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW,
	ROUTE_NAMES.GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_HIERARCHY,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_LINK_TYPES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PRIORITIES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_RESOLUTIONS,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_STATUSES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_SUBTASKS,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TIME_TRACKING,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_WORKFLOW,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES,
	ROUTE_NAMES.SETTINGS_CMDB_FIELD_CONFIG,
]);
